import '@babel/polyfill'
import router from './routes'
import i18n from './i18n'
import store from './store'
import Vue from 'vue'
import MainApp from './MainApp'
import Vuetify from 'vuetify'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import VueQuillEditor from 'vue-quill-editor'
import * as VueGoogleMaps from 'vue2-google-maps/src/main'
import ErrorPage from 'vue-error-page';
import Lightbox from 'vue-easy-lightbox'
import VueScrollTo from 'vue-scrollto'

import 'vuetify/dist/vuetify.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import $ from 'jquery'
import _ from 'lodash'

const moment = require('moment');
require('moment/locale/zh-tw');
require('./bootstrap');

window.$ = $;
window._ = _;
axios.defaults.withCredentials = true;

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { fab } from '@fortawesome/free-brands-svg-icons'
// import { fas } from '@fortawesome/free-solid-svg-icons'
// import { far } from '@fortawesome/free-regular-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// library.add(fab, fas, far);
// Vue.component('font-awesome-icon', FontAwesomeIcon);

// import 'vue-tel-input/dist/vue-tel-input.css';
// import VueTelInput from 'vue-tel-input';
// Vue.use(VueTelInput);

// import infiniteScroll from 'vue-infinite-scroll'
// Vue.use(infiniteScroll);

VueClipboard.config.autoSetContainer = true;
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(VueClipboard);
Vue.use(require('vue-moment'), {
    moment
});
Vue.use(Vuetify, {
    options: {
        themeVariations: ['primary', 'secondary', 'accent'],
        extra: {
            mainToolbar: {
                color: 'primary'
            },
            sideToolbar: {
            },
            sideNav: 'primary',
            mainNav: 'primary lighten-1',
            bodyBg: ''
        }
    },
    iconfont: 'fa' // 'mdi'
});
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAp1V159o0Uo-vhHKse3wfWOUx8e8T-Oqc',
        libraries: 'places', // This is required if you use the Autocomplete plugin

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },
});
window.eventBus = new Vue();
Vue.use(ErrorPage);
Vue.use(Lightbox);

Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

export const app = new Vue({
    el: '#root',
    store,
    router,
    i18n,
    components: { MainApp },
    methods: {

    },
    template: '<MainApp/>'
});
